
import { SettingsService } from "@/services/settings-service";
import Vue from "vue";
export default Vue.extend({
	data(){
		return {
			isSubscribed: false
		};
	},
	methods: {
		onInput(value:boolean){
			if (value){
				this.subscribe();
			}else{
				this.unsubscribe();
			}
		},
		async subscribe(){
			this.isSubscribed = await SettingsService.subscribeToTicketNotifications();
		},
		async unsubscribe(){
			this.isSubscribed = await SettingsService.unsubscribeToTicketNotifications();
		}
	},
	async created(){
		this.isSubscribed = await SettingsService.isSubscribedToTicketNotifications();
	}
});
